import { Injectable } from '@angular/core';
import { AppState } from '@get/store/configs/reducers';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { GeneratedComposantTemplateService } from './composant-template-generated.service';

@Injectable({
  providedIn: 'root'
})
export class ComposantTemplateService extends GeneratedComposantTemplateService {
  constructor(store$: Store<AppState>, actions$: Actions) {
    super(store$, actions$);
  }
}
